import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { usePageMeta } from '../hooks/usePageMeta';
import { getBlogById, isMicroCMSConfigured } from '../lib/microcms';
import { Blog } from '../types/blog';

export const BlogDetailPage = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState<Blog | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  usePageMeta({
    title: blog?.title ?? 'Blog',
    description: blog?.content ? `${blog.title}の記事を掲載しています。` : 'WAOUHのブログ記事です。',
    path: id ? `/blog/${id}` : '/blog',
    image: blog?.eyecatch?.url,
  });

  useEffect(() => {
    const run = async () => {
      if (!id) {
        setError('記事IDが不正です。');
        setLoading(false);
        return;
      }

      try {
        const data = await getBlogById(id);
        setBlog(data);
      } catch (e) {
        setError('記事の取得に失敗しました。');
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [id]);

  if (!isMicroCMSConfigured) {
    return (
      <section>
        <p className="notice">
          準備中
        </p>
        <Link to="/blog" className="read-more">
          ブログ一覧へ戻る
        </Link>
      </section>
    );
  }

  if (loading) {
    return <p className="notice">読み込み中です...</p>;
  }

  if (error || !blog) {
    return (
      <section>
        <p className="notice notice-error">{error ?? '記事が見つかりませんでした。'}</p>
        <Link to="/blog" className="read-more">
          ブログ一覧へ戻る
        </Link>
      </section>
    );
  }

  return (
    <article className="blog-detail">
      <p className="meta">
        {dayjs(blog.publishedAt).format('YYYY.MM.DD')}
        {blog.category?.name ? ` / ${blog.category.name}` : ''}
      </p>
      <h1>{blog.title}</h1>
      {blog.eyecatch?.url && <img src={blog.eyecatch.url} alt={blog.title} className="detail-thumb" />}
      <div dangerouslySetInnerHTML={{ __html: blog.content }} className="blog-content" />
      <Link to="/blog" className="read-more">
        ブログ一覧へ戻る
      </Link>
    </article>
  );
};
